<template>
  <transition name="slide-fade">
    <div v-if="visible" class="messaging-panel-container">
      <div class="messaging-panel">
        <div class="iframe-container">
          <div class="minimal-close" @click="$emit('close')">
            <i class="el-icon-close"></i>
          </div>
          <iframe 
            v-if="workerUrl"
            :src="workerUrl" 
            frameborder="0" 
            class="chat-iframe"
          ></iframe>
          <div v-else class="loading-state">
            <i class="el-icon-loading"></i>
            <p>Connecting to secure chat...</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import request from '@/axios/request';
import { requestConfig } from '@/api/index.js';

export default {
  name: 'MessagingPanel',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      workerUrl: ''
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo || {};
    }
  },
  watch: {
    visible(val) {
      if (val && !this.workerUrl) {
        this.fetchConfig();
      }
    }
  },
  methods: {
    async fetchConfig() {
      const defaultUrl = 'https://chat-worker.mail-488.workers.dev/';
      const backendBase = requestConfig.url;
      
      try {
        const res = await request({
          url: `${backendBase}/message/config`,
          method: 'get'
        });
        
        let url = res.data.workerUrl || defaultUrl;
        if (url.startsWith('wss://')) {
          url = url.replace('wss://', 'https://');
        } else if (url.startsWith('ws://')) {
          url = url.replace('ws://', 'http://');
        }
        
        // Ensure URL ends with / before params
        if (!url.endsWith('/')) url += '/';

        // Append user identity
        const params = new URLSearchParams();
        params.append('userId', res.data.userId || this.userInfo.id || '');
        params.append('username', res.data.username || this.userInfo.nickname || 'Guest');
        params.append('avatar', res.data.avatar || this.userInfo.avatar || '😀');
        
        this.workerUrl = `${url}?${params.toString()}`;
      } catch (err) {
        console.error('Failed to get messaging config, using fallback', err);
        // Fallback using local user info if API fails
        const params = new URLSearchParams();
        params.append('userId', this.userInfo.id || '');
        params.append('username', this.userInfo.nickname || 'Guest');
        params.append('avatar', this.userInfo.avatar || '😀');
        this.workerUrl = `${defaultUrl}?${params.toString()}`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.messaging-panel-container {
  position: fixed;
  right: 20px;
  bottom: 80px;
  width: 400px;
  height: 600px;
  z-index: 2000;
  display: flex;
  flex-direction: column;
}

.messaging-panel {
  flex: 1;
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0,0,0,0.05);
}

.minimal-close {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  color: $gray-500;
  transition: all 0.2s;
  &:hover {
    background: rgba($error-color, 0.1);
    color: $error-color;
    transform: rotate(90deg);
  }
}

.iframe-container {
  flex: 1;
  position: relative;
  background: #fdfdfd;
}

.chat-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.loading-state {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: $gray-500;
  
  i {
    font-size: 24px;
    margin-bottom: 10px;
    color: $primary-color;
  }
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.slide-fade-enter {
  transform: translateY(30px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(30px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/MessagingPanel.vue